module.exports = __webpack_public_path__ + "static/media/new-canvas.f2a81754.svg";